import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="flex items-center space-x-2">
              <span className="text-2xl font-bold text-[#FF9933]">Loïc</span>
              <span className="text-2xl font-bold text-[#1E3A5F]">Duperron</span>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Comment ça marche
            </button>
            <button
              onClick={() => scrollToSection('advantages')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Pourquoi moi
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium"
            >
              Portfolio
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FF9933] hover:bg-[#E68A2E] text-white transition-all duration-200"
            >
              Contact
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#1E3A5F] p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col space-y-3">
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Comment ça marche
              </button>
              <button
                onClick={() => scrollToSection('advantages')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Pourquoi moi
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="text-[#1E3A5F] hover:text-[#FF9933] transition-colors duration-200 font-medium text-left"
              >
                Portfolio
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#FF9933] hover:bg-[#E68A2E] text-white transition-all duration-200 w-full"
              >
                Contact
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
